import { Helper } from '../../Helper';
export class SetObjectAccessorPropertyHelperBase extends Helper {
    constructor({ hasSet = false, hasGet = false }) {
        super();
        this.hasSet = hasSet;
        this.hasGet = hasGet;
        if (!(this.hasSet || this.hasGet)) {
            throw new Error('Something went wrong. Must have either a getter or setter');
        }
    }
    emit(sb, node, optionsIn) {
        const options = sb.pushValueOptions(optionsIn);
        if (!(this.hasSet && this.hasGet)) {
            sb.emitHelper(node, options, sb.helpers.wrapUndefined);
            if (this.hasGet) {
                sb.emitOp(node, 'SWAP');
            }
        }
        sb.emitPushInt(node, 2);
        sb.emitOp(node, 'PACK');
        sb.emitOp(node, 'ROT');
        sb.emitHelper(node, options, this.getObject(sb));
        sb.emitOp(node, 'ROT');
        sb.emitOp(node, 'ROT');
        sb.emitOp(node, 'SETITEM');
    }
}

//# sourceMappingURL=SetObjectAccessorPropertyHelperBase.js.map
